import { Avatar, IconButton, Menu, MenuItem, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { meQueryApiService } from '../../../../api/rtk-queries/extensions/meQueryApiService';
import {getAuth, useGetUser} from '../../../utils/auth';
import { useIsConsultant } from '../../../utils/utilHooks';
import {getConfig} from '../../../utils/config';



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    border:   `${theme.spacing(.1)} solid ${theme.palette.background.paper}`,
    background: theme.palette.primary.main ,
    transition: theme.transitions.create('border-color'),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

export function UserMenu() {
  const isConsultant = useIsConsultant();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const anchorEl = useRef(null);
  const theme = useTheme();
  const { t } = useTranslation();
  // const auth = useAuth(); // TODO Get allowed routes
  const classes = useStyles();
  let title: string | undefined;
  const avatarStyles: React.CSSProperties = {};
  const menuId = 'account-menu';
  let textUserProf = '';
  const { data: imageProfile } = meQueryApiService.useHentIdentitetBildeQuery();
  function handleMenuClose() {
    setMenuOpen(false);
  }
  function handleProfileMenuOpen() {
    setMenuOpen(true);
  }
  async function handleSignout() {
    const config = await getConfig();
    const auth = await getAuth(config);
    handleMenuClose();
    auth.client.signoutRedirect();
  }
  try{
    const user = useGetUser();
    const userNames = user.name?.split(' ');
    textUserProf = !userNames ? '' : userNames[0][0]?.toUpperCase() + userNames[1][0]?.toUpperCase();
    if(isConsultant) {
      avatarStyles.borderColor = theme.palette.error.main;
      title = t('Konsulentpålogging aktivert');
    }
  }catch (e) {
    console.log(e);
  }
  return <>
    
    <IconButton
      ref={anchorEl}
      edge="end"
      aria-label={t('Brukermeny')}
      aria-controls={menuId}
      aria-haspopup="true"
      onClick={handleProfileMenuOpen}
      color="inherit"
      size="small"
      title={title}
    >
      {
        imageProfile?.bilde
          ? <Avatar style={avatarStyles} className={classes.small} src={`data:image/${imageProfile.format};base64,${imageProfile.bilde}`} ></Avatar>
          : <Avatar style={avatarStyles} className={classes.small}>{textUserProf}</Avatar> 
      }

    </IconButton>
    <Menu
      anchorEl={anchorEl.current}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleSignout}>{t('Logg ut')}</MenuItem>
    </Menu>
  </>;
}
